function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_374",
  "data-name": "Group 374",
  transform: "translate(-181.5 -380.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_329",
  "data-name": "Path 329",
  d: "M875.394,222.15v-5.4h25v25h-25v-15.3",
  transform: "translate(-693.394 164.253)",
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_336",
  "data-name": "Group 336",
  transform: "translate(-250.304 135.121)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_40",
  "data-name": "Ellipse 40",
  cx: 3.097,
  cy: 3.097,
  r: 3.097,
  transform: "translate(441.707 255.282)",
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_353",
  "data-name": "Path 353",
  d: "M445.691,253.145a5.635,5.635,0,0,1,.052,9.378",
  transform: "translate(2.211 0.528)",
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_354",
  "data-name": "Path 354",
  d: "M441.239,262.551a5.635,5.635,0,0,1-.052-9.378",
  transform: "translate(0.467 0.535)",
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_355",
  "data-name": "Path 355",
  d: "M445.691,251.03a7.976,7.976,0,0,1,.006,14.7",
  transform: "translate(2.211 0)",
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_356",
  "data-name": "Path 356",
  d: "M441.707,265.728a7.976,7.976,0,0,1-.006-14.7",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})));

var SvgJoratoCasesActiveLightBlue = function SvgJoratoCasesActiveLightBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoratoCasesActiveLightBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jorato-cases-active-light-blue.0ccfc13f.svg";
export { ForwardRef as ReactComponent };